export enum NotificationType {
  NORMAL = "normal",
  IMPORTANT = "important",
}

export type NotificationRead = { luLe: string; luPar: string | null };
